// cafe/client/src/hooks/useLocalization.js
import { useContext, createContext } from 'react';

// 1. Definir y exportar el Context desde este archivo .js
export const LocalizationContext = createContext(null);

// 2. Exportar el hook que usa dicho Context
export const useLocalization = () => {
  const context = useContext(LocalizationContext);
  if (context === undefined) {
    throw new Error(
      'useLocalization must be used within a LocalizationProvider'
    );
  }
  return context;
};
